<template>
  <CardBase elevation="sm" class="flex flex-col justify-between p-4">
    <h3 class="text-mobile-xl font-semibold md:text-xl">{{ file.title }}</h3>
    <h4 v-if="file.authors" class="text-mobile-lg md:text-lg">
      {{ file.authors }}
    </h4>
    <div v-if="file.comment" class="mt-2 md:mt-4">
      <p class="text-shade-500 first-letter:uppercase">
        {{ $t('labels.comment') }}
      </p>
      <p>{{ file.comment }}</p>
    </div>
    <div
      class="mt-2 flex flex-wrap justify-between gap-2 md:mt-10 md:justify-start"
    >
      <BasicButton
        class="flex-1 basis-full py-1 text-sm md:flex-initial md:basis-0"
        @click="download"
      >
        <template #iconLeft>
          <IconDownload class="h-3 w-3" />
        </template>
        <span class="first-letter:uppercase">{{ $t('labels.download') }}</span>
      </BasicButton>
      <DataTag v-if="file.category" :tag="{ label: file.category }" />
      <p v-if="file.size" class="md:grow md:text-right">
        {{ formatBytes(file.size) }}
      </p>
    </div>
  </CardBase>
</template>
<script lang="ts" setup>
import IconDownload from '~/assets/icon/general/Download.svg'
import { PropType } from 'vue'
const props = defineProps({
  file: {
    type: Object as PropType<SidneyFile>,
    required: true,
  },
})

const runtimeConfig = useRuntimeConfig()
const frontHost = runtimeConfig.public.FRONT_HOST

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Octets'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Octets', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

const download = () => {
  if (!props.file.path) {
    const url = useRequestURL()

    return externalRedirect(`${frontHost}/?next=${url.href}`)
  }
  const link = document.createElement('a')
  link.href = props.file.path
  link.download = props.file.originalFileName ?? props.file.title
  link.target = '_blank'
  link.click()
  document.body.removeChild(link)
}
</script>
